import React, { useEffect } from "react";
import useCurrentNotebook from "utilities/hooks/domain/notebooks/use-current-notebook";
import SharedPagesPage from "./shared-pages-display";
import MyPagesDisplay from "./my-pages-display";
import useCurrentPage from "utilities/hooks/domain/notebooks/pages/use-current-page";
import { NotebookConstants } from "constants/notebook-constants";
import { Redirect } from "react-router";
import useNotebooksRedirects from "utilities/hooks/domain/notebooks/use-notebooks-redirects";
import { ToastManager } from "utilities/toast/toast-manager";
import { t } from "utilities/localization-utils";
import { useAtomValue } from "jotai";
import { notebooksLoadingAtom } from "utilities/atoms/notebooks-atom";
import Loader from "atoms/loaders/loader";
import { LoaderStyles } from "atoms/constants/loader-styles";

const BASE_CLASS_NAME = "c-notebook-page";
const INVALID_NOTEBOOK_TOAST_ID = "invalid-route-toast";

const NotebookPage = () => {
    const { currentNotebook } = useCurrentNotebook();
    const isNotebookLoading = useAtomValue(notebooksLoadingAtom);
    const { clear: clearCurrentPage } = useCurrentPage();
    const { redirectToDefaultNotebookRoute } = useNotebooksRedirects();
    useEffect(() => {
        clearCurrentPage();
    }, [currentNotebook, clearCurrentPage]);

    const displaySharedPage = () => {
        return currentNotebook?.id === NotebookConstants.SharedPageNotebookId;
    };

    if (currentNotebook === undefined) {
        ToastManager.warn(t("invalid-notebook-toast"), {
            toastId: INVALID_NOTEBOOK_TOAST_ID,
        });
        return <Redirect to={redirectToDefaultNotebookRoute} />;
    }

    return (
        <div className={BASE_CLASS_NAME}>
            <div className={`${BASE_CLASS_NAME}__container`}>
                {isNotebookLoading ? (
                    <div className={`${BASE_CLASS_NAME}__loaderWrapper`}>
                        <Loader
                            type={LoaderStyles.LinkGlyph}
                            accessibleText={t("loadingItem", {
                                item: t("notebook"),
                            })}
                        />
                    </div>
                ) : displaySharedPage() ? (
                    <SharedPagesPage />
                ) : (
                    <MyPagesDisplay />
                )}
            </div>
        </div>
    );
};

export default NotebookPage;
